import { IRemoveUserPermissionsActionPayload } from '../interfaces/remove-user-permissions.action-payload.interface';

export class RemoveUserPermissionsSuccess {
    static readonly type = '[User] RemoveUserPermissionsSuccess';

    constructor(public payload: IRemoveUserPermissionsActionPayload) {}
}
